define([
    'app/controllers/Controller',
    'app/models/customerService',
    'app/helpers/validator',
    'rv!app/views/customerService',
], function (Controller, CustomerService, Validator, customerServiceTemplate) {
    function ContactController() {
        var Ractive = Controller.ractive;

        function init() {
            var customerService = new CustomerService();
            var validator = new Validator();
            validator.setPage('customerService');

            ractive = new Ractive({
                el: '#customer-service',
                template: customerServiceTemplate,
                magic: true,
                data: $.extend(customerService.data, Ractive.defaults.data), //dont know why, but ractive needs this here of unkown reasons
            });

            //Field valdation
            ractive.observe('fields.*', function (newValue, oldValue, keypath, customerField) {
                customerService.update();

                var that = $('#' + customerField);

                if (that.hasClass('error')) {
                    if (validator.validate(customerField, newValue)) {
                        that.removeClass('error');
                    }
                }
            });

            ractive.on('Input.validateField', function (event) {
                var that = $(event.node);
                var newValue = that.val();
                var customerField = that.attr('name');

                if (!validator.validate(customerField, newValue)) {
                    that.addClass('error');
                } else {
                    that.removeClass('error');
                }

                that.addClass('validated');
            });

            ractive.on(
                'updateFilename',
                (event) => (document.getElementById('filename').innerHTML = event.node.files[0].name)
            );

            ractive.on('postCustomerService', function (event) {
                customerService.post(false, function () {
                    partyking.common.models.messages.warning('inline', 'Formuläret är inte rätt ifyllt!');
                });
            });
        }

        init();
    }

    return ContactController;
});
